// Custom directive for scroll animations
export const scrollAnimation = {
  mounted(el, binding) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Add the class when the element is visible
          if (entry.isIntersecting) {
            el.classList.add('visible');
            // If once is set to true, unobserve after animation
            if (binding.value && binding.value.once) {
              observer.unobserve(el);
            }
          } else if (binding.value && !binding.value.once) {
            // Remove the class when the element is not visible
            // but only if once is not set to true
            el.classList.remove('visible');
          }
        });
      },
      {
        threshold: binding.value && binding.value.threshold ? binding.value.threshold : 0.1,
        rootMargin: binding.value && binding.value.rootMargin ? binding.value.rootMargin : '0px',
      }
    );

    observer.observe(el);
  },
};

export default scrollAnimation;
